import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=5ca5698e&scoped=true&"
import script from "./VerticalSlider.vue?vue&type=script&lang=js&"
export * from "./VerticalSlider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSlider.vue?vue&type=style&index=0&id=5ca5698e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5698e",
  null
  
)

export default component.exports